import axios from "axios";
// import toast from "react-hot-toast";
import { config } from "../../Utils/helpers";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const GetBlogList = (listData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "BLOG_LIST_REQUEST" });
      const { data } = await axios.post(`${BASE_URL}/blog/list`, listData, config);
      if (data.statusCode === 200) {
        dispatch({ type: "BLOG_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "BLOG_LIST_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "BLOG_LIST_FAIL", payload: error?.response });
    }
  };
};

export const GetBlogAllList = (listData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "BLOG_ALL_LIST_REQUEST" });
      const { data } = await axios.post(`${BASE_URL}/blog/all-list`, listData, config);
      if (data.statusCode === 200) {
        dispatch({ type: "BLOG_ALL_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "BLOG_ALL_LIST_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "BLOG_ALL_LIST_FAIL", payload: error?.response });
    }
  };
};

export const AddBlog = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "BLOG_ADD_REQUEST" });
      const { data } = await axios.post(`${BASE_URL}/blog/add`, payload, config);
      if (data.statusCode === 200) {
        dispatch({ type: "BLOG_ADD_SUCCESS", payload: data });
        return Promise.resolve(data);
      } else {
        dispatch({ type: "BLOG_ADD_FAIL", payload: data.message || "Add failed" });
        return Promise.reject(new Error(data.message));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Network error";
      dispatch({ type: "BLOG_ADD_FAIL", payload: errorMessage });
      return Promise.reject(new Error(errorMessage));
    }
  };
};

export const UpdateBlog = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "BLOG_UPDATE_REQUEST" });
      const { data } = await axios.post(`${BASE_URL}/blog/update`, payload, config);
      if (data.statusCode === 200) {
        dispatch({ type: "BLOG_UPDATE_SUCCESS", payload: data });
        return Promise.resolve(data);
      } else {
        dispatch({ type: "BLOG_UPDATE_FAIL", payload: data.message || "Update failed" });
        return Promise.reject(new Error(data.message));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Network error";
      dispatch({ type: "BLOG_UPDATE_FAIL", payload: errorMessage });
      return Promise.reject(new Error(errorMessage));
    }
  };
};

export const UpdateBlogStatus = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "BLOG_STATUS_REQUEST" });
      const { data } = await axios.post(`${BASE_URL}/blog/update-status`, payload, config);
      if (data.statusCode === 200) {
        dispatch({ type: "BLOG_STATUS_SUCCESS", payload: data });
        return Promise.resolve(data);
      } else {
        dispatch({ type: "BLOG_STATUS_FAIL", payload: data.message || "Status update failed" });
        return Promise.reject(new Error(data.message));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Network error";
      dispatch({ type: "BLOG_STATUS_FAIL", payload: errorMessage });
      return Promise.reject(new Error(errorMessage));
    }
  };
};

export const ViewBlog = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "BLOG_VIEW_REQUEST" });
      const { data } = await axios.get(`${BASE_URL}/blog/${id}`, config);
      if (data.statusCode === 200) {
        dispatch({ type: "BLOG_VIEW_SUCCESS", payload: data });
      } else {
        dispatch({ type: "BLOG_VIEW_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "BLOG_VIEW_FAIL", payload: error?.response?.data?.message });
    }
  };
};

export const RemoveBlog = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "BLOG_REMOVE_REQUEST" });
      const { data } = await axios.delete(`${BASE_URL}/blog/remove/${id}`, config);
      if (data.statusCode === 200) {
        dispatch({ type: "BLOG_REMOVE_SUCCESS", payload: data });
        return Promise.resolve(data);
      } else {
        dispatch({ type: "BLOG_REMOVE_FAIL", payload: data.message || "Remove failed" });
        return Promise.reject(new Error(data.message));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Network error";
      dispatch({ type: "BLOG_REMOVE_FAIL", payload: errorMessage });
      return Promise.reject(new Error(errorMessage));
    }
  };
};